import React from "react";
import "./footer.css";
function Footer() {
  return (
    <>
      <footer className="page-footer">
        <div className="container">
          <div className="row">
            <div className="col l4 s12">
              <h5 className="white-text social">About Us</h5>
              <p className="grey-text text-lighten-4">
                In technical sense Lawyers Online may be termed as a portal and
                being a law portal Best plateform to hire a lawyer according to
                case.
              </p>
            </div>
            <div className="col l2 offset-l4 s12">
              <h5 className="white-text social">Social</h5>
              <ul>
                <li>
                  <a className="grey-text text-lighten-3" href="#!">
                    Facebook
                  </a>
                </li>
                <li>
                  <a className="grey-text text-lighten-3" href="#!">
                    Twitter
                  </a>
                </li>
                <li>
                  <a className="grey-text text-lighten-3" href="#!">
                    Instagram
                  </a>
                </li>
                <li>
                  <a className="grey-text text-lighten-3" href="#!">
                    YouTube
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-copyright">
          <p className="container">
            © 2022 Copyright NFC | All Rights Reserved
          </p>
        </div>
      </footer>
    </>
  );
}

export default Footer;
